// extracted by mini-css-extract-plugin
module.exports = {"tabFocus":"App_tabFocus__yc-Ty","darkTabFocus":"App_darkTabFocus__jmP0Q"};